module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/level-3_start-7a5b7e046a74e9928eef848eb843db9e.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/level-3_start.png
// module id = 450
// module chunks = 2